'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ShareButton = require('./ShareButton.css');

var _ShareButton2 = _interopRequireDefault(_ShareButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var urls = {
  twitter: 'https://twitter.com/intent/tweet?url=%URL&text=%TEXT&via=theScore',
  reddit: 'http://www.reddit.com/submit?url=%URL&title=%TEXT',
  facebook: 'https://www.facebook.com/sharer/sharer.php?u=%URL&t=%TEXT'
};

var ShareButton = function (_React$Component) {
  _inherits(ShareButton, _React$Component);

  function ShareButton(props) {
    _classCallCheck(this, ShareButton);

    var _this = _possibleConstructorReturn(this, (ShareButton.__proto__ || Object.getPrototypeOf(ShareButton)).call(this, props));

    _this.state = { showShareContent: false };

    _this.shareClick = _this.shareClick.bind(_this);
    _this.onProxyClick = _this.onProxyClick.bind(_this);
    return _this;
  }

  _createClass(ShareButton, [{
    key: 'onProxyClick',
    value: function onProxyClick(name) {
      var _props = this.props,
          trackEvent = _props.trackEvent,
          shareUrl = _props.shareUrl,
          shareText = _props.shareText;

      var url = urls[name].replace('%URL', encodeURIComponent(shareUrl)).replace('%TEXT', encodeURIComponent(shareText));
      return function shareLink(event) {
        if (trackEvent) {
          trackEvent('share', {
            url: shareUrl,
            social_network: name,
            type: 'content_card'
          });
        }
        var newWindow = window.open() || window;
        newWindow.opener = null; /* Prevent vulnerability */
        newWindow.location = url;
        event.stopPropagation();
      };
    }
  }, {
    key: 'shareClick',
    value: function shareClick(event) {
      this.setState(function (prevState) {
        return {
          showShareContent: !prevState.showShareContent
        };
      });
      event.stopPropagation();
    }
  }, {
    key: 'render',
    value: function render() {
      this.shareText = this.props.shareText;
      this.shareUrl = this.props.shareUrl;
      return _react2.default.createElement(
        'div',
        {
          className: 'jsx-' + _ShareButton2.default.__scopedHash + ' ' + 'shareButton'
        },
        _react2.default.createElement('div', {
          onClick: this.shareClick,
          role: 'button',
          'aria-label': 'Share',
          tabIndex: '0',
          style: this.props.styleOverrides ? this.props.styleOverrides.shareArrowStyles : null,
          className: 'jsx-' + _ShareButton2.default.__scopedHash + ' ' + ('shareArrow ' + (this.props.isLarge ? 'largeArrow' : 'smallArrow') + ' ' + (this.state.showShareContent ? ' hidden' : ''))
        }),
        _react2.default.createElement(
          'div',
          {
            className: 'jsx-' + _ShareButton2.default.__scopedHash + ' ' + ('shareContent ' + (this.state.showShareContent ? '' : ' hidden'))
          },
          _react2.default.createElement('button', { onClick: this.onProxyClick('twitter'), className: 'jsx-' + _ShareButton2.default.__scopedHash + ' ' + 'icon twitterIcon'
          }),
          _react2.default.createElement('button', { onClick: this.onProxyClick('reddit'), className: 'jsx-' + _ShareButton2.default.__scopedHash + ' ' + 'icon redditIcon'
          }),
          _react2.default.createElement('button', { onClick: this.onProxyClick('facebook'), className: 'jsx-' + _ShareButton2.default.__scopedHash + ' ' + 'icon facebookIcon'
          })
        ),
        _react2.default.createElement(_style2.default, {
          styleId: _ShareButton2.default.__scopedHash,
          css: _ShareButton2.default.__scoped
        })
      );
    }
  }]);

  return ShareButton;
}(_react2.default.Component);

ShareButton.propTypes = {
  shareText: _propTypes2.default.string,
  shareUrl: _propTypes2.default.string,
  isLarge: _propTypes2.default.bool,
  trackEvent: _propTypes2.default.func, // eslint-disable-line react/no-unused-prop-types
  styleOverrides: _propTypes2.default.shape({
    shareArrowStyles: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types
  })
};

ShareButton.defaultProps = {
  shareText: null,
  shareUrl: null,
  trackEvent: null,
  isLarge: false,
  styleOverrides: null
};

exports.default = ShareButton;